module.exports = __webpack_public_path__ + "media/images/lps-vs_graph_pc-17924c0e.png";